import { EOnboaringFormStep } from '@constants';

import { useSignWellScript } from '../../../hooks/useSignWellScript';
import { FinalStepWrapper } from '../../../styles';

import { LoadingContract } from './components/LoadingContract';
import { LoadingFinalStep } from './components/LoadingFinalStep';
import { SignContract } from './components/SignContract';

import { useOnboardingFormLogic } from '@/hooks';
import { useProfile } from '@/store';

export const FinalStep = () => {
  const { loadingAfterContract, currentStep } = useOnboardingFormLogic();
  const { isScriptLoaded } = useSignWellScript();
  const { profile } = useProfile();

  if (currentStep !== EOnboaringFormStep.FINAL_STEP || !profile) return null;

  const hasAllRequiredFields =
    profile.legalId &&
    profile.birthday &&
    profile.tags?.length &&
    profile.name &&
    profile.lastName &&
    profile.email;

  if (loadingAfterContract)
    return (
      <FinalStepWrapper>
        <LoadingFinalStep />
      </FinalStepWrapper>
    );

  if (!isScriptLoaded || !hasAllRequiredFields) {
    return (
      <FinalStepWrapper>
        <LoadingContract />
      </FinalStepWrapper>
    );
  }

  return (
    <FinalStepWrapper>
      <SignContract />
    </FinalStepWrapper>
  );
};
